import ChartInteractions from "./lib/chart";
import CalculatorLabels from "./lib/CalculatorLabels";

export default {
    filter: {
        dc: true,
        ac: true,
        hydr: true,
        bypass: false,
        noiseLevel: null,
        fiftyHz: true,
        sixtyHz: true,
    },

    labels: CalculatorLabels,

    memory: null,

    run() {
        this.filterMainCategory()
        this.filterBypass()
        this.filterMotorFrequency()
        this.filterNoiseLevel()

        this.store.listingData = JSON.parse(JSON.stringify(this.memory))
        this.memory = null
    },

    get store() {
        return this.$store.configurator
    },

    get dataLength() {
        return JSON.parse(JSON.stringify(this.store.listingData)).length
    },

    filterMainCategory() {

        this.memory = this.condition(this.store.originalListingData, (item) => {

            if (this.filter.dc && item.main_category === 'dc')
                return true

            if (this.filter.ac && item.main_category === 'ac')
                return true

            if (this.filter.hydr && item.main_category === 'hydr')
                return true

        })
    },

    filterBypass() {
        this.memory = this.condition(this.memory, (item) => {

            if (!this.filter.bypass) {
                return !item['bypass']
            }

            return !!item['bypass'];

        })
    },

    filterMotorFrequency() {
        this.memory = this.condition(this.memory, (item) => {
            const fieldName = this.createFieldName('motorfrequency')

            if (item[fieldName] === null)
                return true

            if (this.filter.fiftyHz && item[fieldName] === '50')
                return true

            if (this.filter.sixtyHz && item[fieldName] === '60')
                return true

        })
    },

    filterNoiseLevel() {
        if (!this.filter.noiseLevel)
            return

        this.memory = this.condition(this.memory,
            item => parseFloat(item[this.createFieldName('noise_level')]) <= parseFloat(this.filter.noiseLevel)
        )
    },

    condition(data, condition) {
        return data.filter(condition)
    },

    createFieldName(suffix) {
        return `${this.store.calculationStyle}_${suffix}`;
    },

    setFiftyHz() {
        if (!this.filter.ac) {
            this.resetRadioButtons()
            return
        }

        this.store.displayStyle = 'metric'
        this.resetRadioButtons()
        ChartInteractions.updateChartData()
    },

    setSixtyHz() {
        if (!this.filter.ac) {
            this.resetRadioButtons()
            return
        }

        this.store.displayStyle = 'imperial'
        this.resetRadioButtons()
        ChartInteractions.updateChartData()
    },

    get fiftyHz() {
        return this.store.displayStyle === 'metric'
    },

    get sixtyHz() {
        return this.store.displayStyle === 'imperial'
    },

    resetHzRadio() {
        this.store.displayStyle = this.store.calculationStyle
        this.resetRadioButtons()
    },

    resetRadioButtons() {
        this.$el.querySelectorAll('input[type=radio]').forEach(box => {

            if (box.name === '50hz') {
                box.checked = this.store.displayStyle === 'metric'
            }

            if (box.name === '60hz') {
                box.checked = this.store.displayStyle === 'imperial'
            }

        })
    }

}
